import React from "react";
import { useAppSelector } from "src/store/store";
import { Text } from "@amzn/meridian";
import "./containerCountOverlay.scss";

const ContainerCountOverlay: React.FC = () => {
  const { currentIterationIndex, totalIterations } = useAppSelector((state) => state.workflow);

  if (totalIterations <= 0) {
    return null;
  }

  return (
    <div className="container-count-overlay">
      <Text color="inverted" type="b200" className="container-count-overlay__text">
        Container {currentIterationIndex + 1} of {totalIterations}
      </Text>
    </div>
  );
};

export default ContainerCountOverlay;
